import {inject, Injectable} from '@angular/core';
import {BaseModalApiService} from "../../../../../../../core/components/modals/services/base-modal-api.service";
import {CreateTestingResultData} from "../types/create-testing-result.types";
import {RecordData} from "../../../../../../../core/types/records-table.types";
import {testingResultResourceType} from "../configs/create-component-config";

@Injectable({
  providedIn: 'root'
})
export class CreateTestingResultService {
  private baseModalApiService: BaseModalApiService = inject(BaseModalApiService);

  public createTestingResultData(params: CreateTestingResultData): Promise<RecordData> {
    return new Promise((resolve, reject) => {
      this.baseModalApiService.createDataInModal<CreateTestingResultData, RecordData>(params, testingResultResourceType.path).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }
}
